import styled, { keyframes, css } from 'styled-components';

const STATUS_DOT_ACTIVE_COLOR = '#707070';
const STATUS_DOT_INACTIVE_COLOR = 'rgba(112, 112, 112, 0.35)';

const statusDotCycle = keyframes`
  0%,
  55%,
  100% {
    background-color: ${STATUS_DOT_INACTIVE_COLOR};
    opacity: 0.7;
    transform: scale(1);
  }
  22% {
    background-color: ${STATUS_DOT_ACTIVE_COLOR};
    opacity: 1;
    transform: scale(1.25);
  }
`;

/** Crossfade: text fades in when the component mounts (key change re-mounts it) */
const fadeIn = keyframes`
  from { opacity: 0; }
  to   { opacity: 1; }
`;

/**
 * Shimmer sweep: a gradient highlight moves across the text left-to-right.
 * Uses a background-clip trick — the element must have a transparent color so
 * the gradient shows through.
 */
const shimmerSweep = keyframes`
  0%   { background-position: -200% center; }
  100% { background-position:  200% center; }
`;

export const StatusIndicatorContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: flex-start;
  padding-right: 40px;
`;

export const StatusIndicatorDotsRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
`;

export const StatusIndicatorDot = styled.span<{ $size: number; $delayMs: number }>`
  display: inline-block;
  width: ${({ $size }) => `${$size}px`};
  height: ${({ $size }) => `${$size}px`};
  border-radius: 50%;
  background: ${STATUS_DOT_INACTIVE_COLOR};
  animation: ${statusDotCycle} 1.05s cubic-bezier(0.22, 1, 0.36, 1) infinite;
  animation-delay: ${({ $delayMs }) => `${$delayMs}ms`};
  transform-origin: center;
  will-change: transform, opacity, background-color;
`;

export const StatusIndicatorText = styled.p<{ $shimmer?: boolean }>`
  margin: 0;

  /* Crossfade: fade in on every remount (triggered by React key change) */
  animation: ${fadeIn} 300ms ease forwards;

  ${({ $shimmer }) =>
    $shimmer
      ? css`
          /* Shimmer sweep effect — spec: 50% width, 1500ms, 340°, 500ms delay */
          background: linear-gradient(
            340deg,
            var(--t-brand-alt-color, #707070) 35%,
            rgba(180, 180, 180, 0.9) 50%,
            var(--t-brand-alt-color, #707070) 65%
          );
          background-size: 200% auto;
          -webkit-background-clip: text;
          background-clip: text;
          -webkit-text-fill-color: transparent;
          color: transparent;
          animation: ${fadeIn} 300ms ease forwards, ${shimmerSweep} 1500ms linear 500ms infinite;
        `
      : css`
          color: var(--t-brand-alt-color, #707070) !important;
        `}
`;
